export function getLocalTimeZoneId(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export default getLocalTimeZoneId;
